import { lazyPage } from 'app/client/utilities/lazy';

export default lazyPage(() => import(/* webpackChunkName: "ticket_feedback.index" */ './index'));
